import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { formatNumber } from '~/utils';

import type { TypeStockReleaseDetailItem } from '~/types/stock.types';

const formatRequestQuantity = (value: unknown): string => formatNumber(typeof value === 'number' ? value : 0);

/** 반출 완료 수량은 패킹 전이면 숫자가 아닌 안내 문자열이 올 수 있어 그대로 보인다. */
const formatActualQuantity = (value: unknown): string => {
  if (typeof value === 'number' && !isNaN(value)) return formatNumber(value);
  return value ? String(value) : '-';
};

const RIGHT_ALIGN = { cellStyle: { textAlign: 'right' } } as const;

/**
 * [재고관리 > 반출 요청 관리] 반출 요청 상세 > 반출 요청 상품 테이블
 */
const getStockReleaseDetailItemsColumnDefs = () => {
  const getRowId = (row: TypeStockReleaseDetailItem) => String(row.skuCode);

  const columnDefs: TypeTableColumn<TypeStockReleaseDetailItem>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 72,
    },
    {
      accessorKey: 'skuCode',
      header: 'SKU코드',
      size: 140,
    },
    {
      accessorKey: 'barcode',
      header: '상품 바코드',
      size: 140,
    },
    {
      accessorKey: 'skuName',
      header: '상품명',
      size: 240,
    },
    {
      accessorKey: 'temperatureTypeCodeObject.name',
      header: '보관 유형',
      size: 76,
    },
    {
      accessorKey: 'availableRequestQuantity',
      header: '반출 요청 수량 (가용)',
      size: 142,
      cell: ({ getValue }) => formatRequestQuantity(getValue()),
      meta: RIGHT_ALIGN,
    },
    {
      accessorKey: 'defectiveRequestQuantity',
      header: '반출 요청 수량 (불용)',
      size: 142,
      cell: ({ getValue }) => formatRequestQuantity(getValue()),
      meta: RIGHT_ALIGN,
    },
    {
      accessorKey: 'availableActualQuantity',
      header: '반출 완료 수량 (가용)',
      size: 142,
      cell: ({ getValue }) => formatActualQuantity(getValue()),
      meta: RIGHT_ALIGN,
    },
    {
      accessorKey: 'defectiveActualQuantity',
      header: '반출 완료 수량 (불용)',
      size: 142,
      cell: ({ getValue }) => formatActualQuantity(getValue()),
      meta: RIGHT_ALIGN,
    },
  ];

  return { getRowId, columnDefs };
};

export default getStockReleaseDetailItemsColumnDefs;
